import script from "./loans-savings-entry.vue?vue&type=script&setup=true&lang=js"
export * from "./loans-savings-entry.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__